
import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice.js'
import organizationReducer from './slices/organizationSlice.js'
import employeeReducer from './slices/employeeSlice.js'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    organization: organizationReducer,
    employee: employeeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: import.meta.env.VITE_ENABLE_DEV_TOOLS === 'true',
})

export default store